import { Layers, PinDrop, Settings, SettingsOutlined, Straighten, ViewList } from "@mui/icons-material";

import { CORE_DRAWER_IDS, DispatchDrawers, drawersActions } from "contexts/drawers";
import ObjectTreeIcon from "media/icons/object-tree.svg?react";
import PropertiesIcon from "media/icons/properties.svg?react";

import { DimensionDrawerPanel } from "../core/dimension/DimensionDrawerPanel";
// Import panel components - they work for drawers too since they just need onClose prop
import {
    AllItemsPanel,
    DeviationsPanel,
    GroupsPanel,
    ObjectsPanel,
    PropertiesPanel,
    SettingsPanel,
    ViewsMarkupsPanel,
} from "../sidePanel/panels";

/**
 * Register all built-in drawers.
 * Call this once during app initialization.
 *
 * Note: We reuse the same panel components since DrawerProps is compatible with SidePanelProps.
 */
export function registerCoreDrawers(dispatch: DispatchDrawers) {
    dispatch(
        drawersActions.registerDrawer({
            id: CORE_DRAWER_IDS.VIEWS_MARKUPS,
            title: "Views & Markups",
            icon: <ViewList />,
            component: ViewsMarkupsPanel,
        }),
    );

    dispatch(
        drawersActions.registerDrawer({
            id: CORE_DRAWER_IDS.ALL_ITEMS,
            title: "All Items",
            icon: <PinDrop />,
            component: AllItemsPanel,
        }),
    );

    dispatch(
        drawersActions.registerDrawer({
            id: CORE_DRAWER_IDS.OBJECTS,
            title: "Objects",
            icon: <ObjectTreeIcon />,
            component: ObjectsPanel,
        }),
    );

    dispatch(
        drawersActions.registerDrawer({
            id: CORE_DRAWER_IDS.PROPERTIES,
            title: "Properties",
            icon: <PropertiesIcon />,
            component: PropertiesPanel,
        }),
    );

    dispatch(
        drawersActions.registerDrawer({
            id: CORE_DRAWER_IDS.GROUPS,
            title: "Groups",
            icon: <Layers />,
            component: GroupsPanel,
        }),
    );

    dispatch(
        drawersActions.registerDrawer({
            id: CORE_DRAWER_IDS.DEVIATIONS,
            title: "Deviations",
            icon: <Settings />,
            component: DeviationsPanel,
        }),
    );

    dispatch(
        drawersActions.registerDrawer({
            id: CORE_DRAWER_IDS.SETTINGS,
            title: "Settings",
            icon: <SettingsOutlined />,
            component: SettingsPanel,
        }),
    );

    dispatch(
        drawersActions.registerDrawer({
            id: CORE_DRAWER_IDS.DIMENSION,
            title: "Dimension",
            icon: <Straighten />,
            component: DimensionDrawerPanel,
        }),
    );
}
